import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDrjQG3Be61p03uDG-vjP9zoIcEVI-fyQk",
  authDomain: "app1base-8a8ac.firebaseapp.com",
  databaseURL: "https://app1base-8a8ac-default-rtdb.firebaseio.com",
  projectId: "app1base-8a8ac",
  storageBucket: "app1base-8a8ac.firebasestorage.app",
  messagingSenderId: "791621171816",
  appId: "1:791621171816:web:b13bd9d060ed7c26ee19dd",
  measurementId: "G-8QRRB40X9R"
};

// Instance principale
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Seconde instance pour la création d'utilisateurs
const secondaryApp = initializeApp(firebaseConfig, 'Secondary');
const secondaryAuth = getAuth(secondaryApp);

// Exporter toutes les instances en une seule fois
export { db, auth, storage, secondaryAuth };

